import { render, staticRenderFns } from "./PharmaceuticalScientist.vue?vue&type=template&id=1731e154&"
import script from "./PharmaceuticalScientist.vue?vue&type=script&lang=js&"
export * from "./PharmaceuticalScientist.vue?vue&type=script&lang=js&"
import style0 from "./PharmaceuticalScientist.vue?vue&type=style&index=0&id=1731e154&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports